// Editor theme tokens.
//
// We now share the same dark palette as the admin chrome — the editor
// area is no longer a "light sheet of paper inside dark shell" (which
// caused jarring white flashes). Tokens mirror the CSS variables in
// src/styles.css; we keep them in TS too because block editors compose
// values dynamically (rgba mixing, etc.) where var() doesn't work.

export const t = {
  // Surfaces
  bg: "#1c1c1e",
  card: "#2c2c2e",
  cardRaised: "#3a3a3c",

  // Borders
  border: "rgba(255, 255, 255, 0.08)",
  borderStrong: "rgba(255, 255, 255, 0.18)",

  // Text
  text: "#f2f2f7",
  text2: "#d1d1d6",
  text3: "#8e8e93",
  text4: "#636366",

  // Accent (bronze)
  accent: "#b8864a",
  accentSoft: "rgba(184, 134, 74, 0.14)",
  accentStrong: "rgba(184, 134, 74, 0.45)",

  // Semantic
  danger: "#e05252",
  dangerSoft: "rgba(224, 82, 82, 0.14)",
  success: "#3ecf71",
  successSoft: "rgba(62, 207, 113, 0.14)",

  // Interaction
  hover: "rgba(255, 255, 255, 0.05)",
  selectedBorder: "rgba(184, 134, 74, 0.55)",
  selectedBg: "rgba(184, 134, 74, 0.07)",

  // Fonts
  serif:
    '"Iowan Old Style", "Apple Garamond", Georgia, "Times New Roman", serif',
  sans:
    '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", Arial, sans-serif',
  mono:
    'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
  transition: "all 150ms cubic-bezier(0.2, 0, 0.2, 1)",
} as const;
